import store from '@/store'

export default class UserGroupsInfo {
  /**
   *  Cognito EAP_grow Group
   */
  static get EAP_GROW() {
    return 'EAP_Grow'
  }

  /**
   *  Cognito OverlapedAreaDisplayUser Group
   */
  static get OVERLAPED_AREA_DISPLAY_USER() {
    return 'OverlapedAreaDisplayUser'
  }

  static groupNames() {
    const userGroupsInfo = store.getters.userGroupsInfo
    if (userGroupsInfo) {
      const groups = userGroupsInfo.userGroups
      if (groups) {
        return userGroupsInfo.userGroups.map(ug => ug.name)
      }
    }
    return []
  }

  static match(groupName) {
    if (!groupName) {
      return false
    }
    return UserGroupsInfo.groupNames().includes(groupName)
  }
}
